import {UcoastEl} from "@/scripts/core/UcoastEl"
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class ProductCard extends UcoastEl {
  static htmlSelector = 'product-card'

  colors: undefined | NodeListOf<HTMLElement>
  images: undefined | NodeListOf<HTMLElement>
  // The colour the card is "resting" on (last clicked / server-preselected). Hover previews
  // another colour's image, then we revert to this one on mouse-out.
  selectedColorId: string | undefined

  constructor() {
    super()

    this.colors = q.ol('[data-uc-product-variant-color]', this)
    this.images = q.ol('[data-uc-product-variant-image]', this)

    if (this.colors && this.colors.length) {
      const canHover = window.matchMedia('(hover: hover)').matches
      if (canHover) {
        // Warm the (lazy) variant images on first card hover so the subsequent swatch
        // hover/switch is instant instead of waiting on a cold network fetch.
        this.addEventListener('pointerenter', this.preloadImages.bind(this), { once: true })
      }
      this.colors.forEach(color => {
        color.addEventListener('click', this.onColorClick.bind(this))
        if (canHover) {
          // Desktop only: preview the colour's image on swatch hover, revert on leave.
          const label = this.querySelector(`label[for="${color.id}"]`) as HTMLElement | null
          const hoverEl = label || color
          const colorId = q.oa(color, 'data-uc-product-variant-color')
          hoverEl.addEventListener('mouseenter', () => this.showImage(colorId))
          hoverEl.addEventListener('mouseleave', () => this.revertImage())
        }
      })
      // Honour a server-marked preselected colour (e.g. Shop All colour filter) so the matching
      // swatch/image is shown. Falls back to the first colour when none is marked.
      const preselect = this.querySelector('[data-uc-variant-preselect]') as HTMLElement | null
      ;(preselect || this.colors[0]).click()
    }
  }

  onColorClick(event: Event) {
    const target = q.rt<Event, HTMLElement>(event)
    this.selectedColorId = q.oa(target, 'data-uc-product-variant-color')
    this.showImage(this.selectedColorId)
  }

  revertImage() {
    this.showImage(this.selectedColorId)
  }

  preloadImages() {
    if (!this.images) return
    this.images.forEach(span => {
      span.querySelectorAll('img').forEach(img => {
        if (img.loading === 'lazy') img.loading = 'eager'
      })
    })
  }

  showImage(colorId: string | undefined) {
    if (!this.images || colorId === undefined) return
    this.images.forEach(image => {
      const item = q.oa(image, 'data-uc-product-variant-image')
      image.classList.toggle('active', colorId === item)
    })
  }
}
